(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nks-mega-navigation')) {
    customElements.define('nks-mega-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.menus = Array.from(this.querySelectorAll('.nks-mega-menu'));
        this.menus.forEach(menu => {
          const trigger = menu.querySelector('.nks-mega-menu__trigger');
          const panel = menu.querySelector('.nks-mega-menu__panel');
          menu.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !matchMedia('(min-width: 990px)').matches) return;
            this.openMenu(menu);
          }, options);
          menu.addEventListener('pointerleave', () => {
            this.closeTimer = setTimeout(() => {
              if (!panel.contains(document.activeElement)) this.closeMenus();
            }, 180);
          }, options);
          menu.addEventListener('focusout', event => {
            if (!menu.contains(event.relatedTarget)) this.closeMenus();
          }, options);
          trigger.addEventListener('keydown', event => {
            if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
            event.preventDefault();
            this.openMenu(menu);
            const links = panel.querySelectorAll('a[href]');
            const nextLink = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
            nextLink?.focus();
          }, options);
        });
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.closeMenus();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const openMenu = this.menus.find(menu => !menu.querySelector('.nks-mega-menu__panel').hidden);
          this.closeMenus();
          openMenu?.querySelector('.nks-mega-menu__trigger').focus();
        }, options);
        window.addEventListener('resize', () => this.closeMenus(), options);
        window.addEventListener('scroll', () => this.closeMenus(), { ...options, passive: true });
      }

      openMenu(menu) {
        clearTimeout(this.closeTimer);
        this.closeMenus(menu);
        menu.querySelector('.nks-mega-menu__panel').hidden = false;
        menu.querySelector('.nks-mega-menu__trigger').setAttribute('aria-expanded', 'true');
      }

      closeMenus(except) {
        this.menus.forEach(menu => {
          if (menu === except) return;
          menu.querySelector('.nks-mega-menu__panel').hidden = true;
          menu.querySelector('.nks-mega-menu__trigger').setAttribute('aria-expanded', 'false');
        });
      }

      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nks-collection-infinite-scroll"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nks-collection-pagination')) {
    customElements.define('nks-collection-pagination', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.parentElement.querySelector('#product-grid');
        this.button = this.querySelector('[data-collection-load-more]');
        this.label = this.querySelector('[data-collection-load-label]');
        this.status = this.querySelector('[data-collection-load-status]');
        if (!this.grid || this.grid.tagName !== 'UL') return;
        this.nextUrl = this.dataset.nextUrl;
        this.currentPage = Number(this.dataset.currentPage);
        this.loadedUrls = new Set();
        this.seen = new Set(Array.from(this.grid.children, item => item.dataset.productId));
        this.defaultLabel = this.label?.textContent;
        this.dataset.enhanced = 'true';
        this.dataset.state = this.nextUrl ? 'idle' : 'complete';
        if (!this.button || !this.nextUrl) return;
        this.onClick = () => this.loadNextPage();
        this.button.addEventListener('click', this.onClick);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting) && this.dataset.state === 'idle') {
              this.loadNextPage();
            }
          }, { rootMargin: '900px 0px', threshold: 0 });
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.button?.removeEventListener('click', this.onClick);
      }

      async loadNextPage() {
        if (!this.isConnected || !this.nextUrl || this.dataset.state === 'loading') return;
        if (this.closest('.collection')?.classList.contains('loading')) return;
        const url = new URL(this.nextUrl, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
        url.searchParams.set('section_id', this.dataset.sectionId);
        if (this.loadedUrls.has(url.href)) return;
        this.dataset.state = 'loading';
        this.grid.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.label.textContent = this.dataset.labelLoading;
        this.status.textContent = this.dataset.labelLoading;
        this.controller = new AbortController();
        const timeout = window.setTimeout(() => this.controller.abort(), 12000);

        try {
          const response = await fetch(url.href, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.controller.signal
          });
          if (!response.ok) throw new Error('Collection page unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = parsed.getElementById('product-grid');
          const nextPagination = parsed.querySelector('nks-collection-pagination');
          if (!nextGrid || !nextPagination || nextPagination.dataset.sectionId !== this.dataset.sectionId) {
            throw new Error('Collection grid unavailable');
          }
          const nextPage = Number(nextPagination.dataset.currentPage);
          if (nextPage <= this.currentPage) throw new Error('Collection page did not advance');
          if (!this.isConnected || this.closest('.collection')?.classList.contains('loading')) return;
          const fragment = document.createDocumentFragment();
          let count = 0;
          Array.from(nextGrid.children).forEach(item => {
            const id = item.dataset.productId;
            if (!id || this.seen.has(id)) return;
            this.seen.add(id);
            item.classList.add('scroll-trigger--cancel');
            fragment.appendChild(item);
            count += 1;
          });
          this.grid.appendChild(fragment);
          this.loadedUrls.add(url.href);
          this.currentPage = nextPage;
          this.dataset.currentPage = String(nextPage);
          this.nextUrl = nextPagination.dataset.nextUrl;
          this.dataset.nextUrl = this.nextUrl;
          this.dataset.state = this.nextUrl ? 'idle' : 'complete';
          this.label.textContent = this.defaultLabel;
          this.status.textContent = this.nextUrl
            ? this.dataset.labelLoaded.replace('__COUNT__', String(count))
            : this.dataset.labelComplete;
          if (!this.nextUrl) this.observer?.disconnect();
        } catch (error) {
          if (!this.isConnected) return;
          this.dataset.state = 'retry';
          this.label.textContent = this.dataset.labelRetry;
          this.status.textContent = this.dataset.labelRetry;
        } finally {
          window.clearTimeout(timeout);
          this.grid.setAttribute('aria-busy', 'false');
          this.button.disabled = false;
          if (this.isConnected && this.dataset.state === 'idle') {
            window.requestAnimationFrame(() => {
              const rect = this.getBoundingClientRect();
              if (rect.top < window.innerHeight + 900 && rect.bottom > -900) this.loadNextPage();
            });
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nks-commerce-polish"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.nksNativeCartAdditionReady) return;
    window.nksNativeCartAdditionReady = true;
    let feedbackTimer;
    let settleTimer;
    let additionQueue = Promise.resolve();
    let operationId = 0;
    const pending = new Map();
    let confirmedCount = Number(document.querySelector('#cart-icon-bubble .cart-count-bubble [aria-hidden="true"]')?.textContent || document.querySelector('.nks-mobile-dock__count')?.textContent || 0);
    const cartRoot = window.Shopify?.routes?.root || '/';
    const cartTargets = () => [document.getElementById('cart-icon-bubble'), document.querySelector(`.nks-mobile-dock__item[href="${window.routes?.cart_url || '/cart'}"]`)].filter(Boolean);
    const pendingCount = () => [...pending.values()].reduce((total, quantity) => total + quantity, 0);
    const countMessage = (count) => document.querySelector('[data-ih-cart-status]')?.dataset.countMessage.replace('__COUNT__', String(count)) || String(count);

    const renderCount = () => {
      const count = confirmedCount + pendingCount();
      const header = document.getElementById('cart-icon-bubble');
      if (header) {
        let bubble = header.querySelector('.cart-count-bubble');
        if (!bubble && count > 0) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          header.append(bubble);
        }
        if (bubble) {
          bubble.hidden = count === 0;
          let number = bubble.querySelector('[aria-hidden="true"]');
          if (!number) {
            number = document.createElement('span');
            number.setAttribute('aria-hidden', 'true');
            bubble.prepend(number);
          }
          number.textContent = String(count);
          let label = bubble.querySelector('.visually-hidden');
          if (!label) {
            label = document.createElement('span');
            label.className = 'visually-hidden';
            bubble.append(label);
          }
          label.textContent = countMessage(count);
          bubble.classList.toggle('ih-cart-count-large', count >= 100);
        }
      }
      document.querySelectorAll('.nks-mobile-dock__count').forEach((badge) => {
        badge.textContent = String(count);
        badge.classList.toggle('is-empty', count === 0);
        badge.classList.toggle('ih-cart-count-large', count >= 100);
        badge.setAttribute('aria-label', countMessage(count));
      });
    };

    const startRefresh = () => {
      window.clearTimeout(settleTimer);
      cartTargets().forEach((target) => {
        target.classList.add('ih-cart-is-refreshing');
        target.setAttribute('aria-busy', 'true');
      });
      renderCount();
    };

    const settleRefresh = () => {
      renderCount();
      if (pending.size) return;
      cartTargets().forEach((target) => target.removeAttribute('aria-busy'));
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(() => cartTargets().forEach((target) => target.classList.remove('ih-cart-is-refreshing')), 1200);
    };

    const showError = (message) => {
      const feedback = document.querySelector('.nks-commerce-feedback');
      if (!feedback) return;
      window.clearTimeout(feedbackTimer);
      feedback.textContent = message;
      feedback.dataset.state = 'error';
      feedback.classList.add('is-visible');
      feedbackTimer = window.setTimeout(() => feedback.classList.remove('is-visible'), 6500);
    };

    const acceptCart = (cart) => {
      if (!Number.isFinite(cart?.item_count)) return;
      if (!pending.size) confirmedCount = cart.item_count;
      renderCount();
    };

    const readCart = async () => {
      const response = await fetch(`${cartRoot}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    };

    const refresh = () => readCart().then(acceptCart).catch(() => {});
    window.IHCartFeedback = { acceptCart, refresh };

    const updateRenderedCart = (sections) => {
      if (!sections) return;
      if (sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const source = html.querySelector('.shopify-section');
        const target = document.getElementById('cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      }
      if (sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const source = html.querySelector('.drawer__inner');
        const target = document.querySelector('cart-drawer .drawer__inner');
        if (source && target) target.replaceWith(source);
        document.querySelector('cart-drawer')?.classList.remove('is-empty');
      }
    };

    const performAddition = async (operation) => {
      const { form, button, formData, controls, quantity, id } = operation;
      let additionConfirmed = false;
      let cart;
      let data;
      try {
        const response = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || document.querySelector('.nks-commerce-feedback')?.dataset.errorMessage);
        additionConfirmed = true;
        try { cart = await readCart(); } catch (error) { cart = null; }
        pending.delete(id);
        confirmedCount = Number.isFinite(cart?.item_count) ? cart.item_count : confirmedCount + quantity;
        updateRenderedCart(data.sections);
        renderCount();
        const status = document.querySelector('[data-ih-cart-status]');
        if (status) status.textContent = `${status.dataset.successMessage} ${countMessage(confirmedCount)}`;
        form.dispatchEvent(new CustomEvent('ih:added-to-cart', { bubbles: true, detail: { quantity, variantId: formData.get('id'), cart } }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nks-native-cart-addition', productVariantId: formData.get('id'), cartData: cart || data });
        }
      } catch (error) {
        if (!additionConfirmed) {
          pending.delete(id);
          try { const actualCart = await readCart(); confirmedCount = actualCart.item_count; } catch (readError) {}
          showError(error.message || document.querySelector('.nks-commerce-feedback')?.dataset.errorMessage);
        }
      } finally {
        pending.delete(id);
        controls.forEach(({ control, disabled }) => { if (control.isConnected) control.disabled = disabled; });
        button?.removeAttribute('aria-busy');
        delete form.dataset.nksCartBusy;
        settleRefresh();
      }
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      const button = event.submitter;
      if (!(form instanceof HTMLFormElement)) return;
      const action = new URL(form.action, window.location.origin);
      if (action.origin !== window.location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.nksCartBusy === 'true') return;
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const requiredUpload = [...form.querySelectorAll('.fs-upload[data-required="true"]')].find((upload) => !upload.querySelector('[name="properties[Custom Design]"]')?.value);
      if (requiredUpload) {
        requiredUpload.classList.add('fs-upload--invalid');
        const message = requiredUpload.querySelector('.fs-upload__error');
        if (message) { message.textContent = requiredUpload.dataset.errorRequired; message.style.display = 'block'; }
        requiredUpload.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const formData = new FormData(form);
      if (!formData.get('id')) return;
      const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
      const id = ++operationId;
      form.dataset.nksCartBusy = 'true';
      const controls = Array.from(new Set([...form.elements].filter((control) => control instanceof HTMLButtonElement && control.type === 'submit').concat(button || [])), (control) => ({ control, disabled: control.disabled }));
      controls.forEach(({ control }) => { control.disabled = true; });
      button?.setAttribute('aria-busy', 'true');
      document.querySelector('.nks-commerce-feedback')?.classList.remove('is-visible');
      formData.delete('return_to');
      formData.append('sections', 'cart-icon-bubble,cart-drawer');
      formData.append('sections_url', window.location.pathname);
      pending.set(id, quantity);
      startRefresh();
      additionQueue = additionQueue.then(() => performAddition({ form, button, formData, controls, quantity, id }), () => performAddition({ form, button, formData, controls, quantity, id }));
    }, true);

    const initialize = () => {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
        if (Number.isFinite(cartData?.item_count)) acceptCart(cartData);
        else if (!pending.size) refresh();
      });
      renderCount();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    window.addEventListener('pageshow', refresh);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nks-product-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nks-cart-line-note')) {
    customElements.define(
      'nks-cart-line-note',
      class NksCartLineNote extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;

          this.dataset.bound = 'true';
          this.input = this.querySelector('textarea');
          this.status = this.querySelector('[role="status"]');
          this.properties = {};
          this.savedValue = this.input.value;
          this.saveTimer = null;
          this.saving = false;
          this.needsSave = false;

          this.querySelectorAll('[data-property-name][data-property-value]').forEach((property) => {
            this.properties[property.dataset.propertyName] = property.dataset.propertyValue;
          });

          this.input.addEventListener('input', () => {
            window.clearTimeout(this.saveTimer);

            if (this.input.value === this.savedValue) {
              this.setStatus('');
              return;
            }

            this.setStatus('saving');
            this.saveTimer = window.setTimeout(() => this.save(), 650);
          });

          this.input.addEventListener('blur', () => {
            window.clearTimeout(this.saveTimer);
            this.save();
          });
        }

        disconnectedCallback() {
          window.clearTimeout(this.saveTimer);
        }

        setStatus(state) {
          const messages = {
            saving: this.dataset.savingMessage,
            saved: this.dataset.savedMessage,
            error: this.dataset.errorMessage,
          };

          this.status.dataset.state = state;
          this.status.textContent = messages[state] || '';
        }

        propertiesMatch(firstProperties, secondProperties) {
          const first = firstProperties || {};
          const second = secondProperties || {};
          const firstKeys = Object.keys(first).sort();
          const secondKeys = Object.keys(second).sort();

          return (
            firstKeys.length === secondKeys.length &&
            firstKeys.every((key, index) => key === secondKeys[index] && String(first[key]) === String(second[key]))
          );
        }

        async save() {
          window.clearTimeout(this.saveTimer);

          if (this.saving) {
            this.needsSave = true;
            return;
          }

          const inputValue = this.input.value;
          const valueToSave = inputValue.trim();
          if (valueToSave === this.savedValue) {
            this.setStatus(valueToSave ? 'saved' : '');
            return;
          }

          const nextProperties = { ...this.properties };
          if (valueToSave) {
            nextProperties[this.dataset.propertyName] = valueToSave;
          } else {
            delete nextProperties[this.dataset.propertyName];
          }

          this.saving = true;
          this.needsSave = false;
          this.setStatus('saving');

          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart/change.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: this.dataset.lineKey,
                quantity: Number(this.dataset.quantity),
                properties: nextProperties,
              }),
            });

            if (!response.ok) throw new Error('Cart line update failed');

            const cart = await response.json();
            const variantId = Number(this.dataset.variantId);
            const updatedItem = cart.items.find(
              (cartItem) => cartItem.variant_id === variantId && this.propertiesMatch(cartItem.properties, nextProperties)
            );

            if (!updatedItem) throw new Error('Updated cart line was not returned');

            this.properties = { ...(updatedItem.properties || {}) };
            this.savedValue = valueToSave;
            this.dataset.lineKey = updatedItem.key;
            this.dataset.quantity = String(updatedItem.quantity);
            this.dataset.lineIndex = String(cart.items.indexOf(updatedItem) + 1);

            if (this.input.value === inputValue) {
              this.input.value = valueToSave;
              this.setStatus(valueToSave ? 'saved' : '');
            } else {
              this.needsSave = true;
            }

            const cartItems = this.closest('cart-items, cart-drawer-items');
            if (cartItems && cartItems.querySelectorAll('.cart-item').length !== cart.items.length) {
              await cartItems.onCartUpdate?.();
            }
          } catch (error) {
            this.setStatus('error');
          } finally {
            this.saving = false;
            if (this.needsSave && this.isConnected) {
              this.saveTimer = window.setTimeout(() => this.save(), 150);
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nks-product-top-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nks-product-top-actions')) {
    customElements.define('nks-product-top-actions', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.addButton = this.querySelector('[data-nks-top-add]');
        this.syncButtons = () => {
          const original = this.productInfo?.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`) || this.productInfo?.querySelector('.nks-pancho-purchase [data-nks-ajax-add]');
          const disabled = !original || original.disabled || original.getAttribute('aria-disabled') === 'true';
          if (this.addButton.disabled !== disabled) this.addButton.disabled = disabled;
        };
        this.observer = new MutationObserver(this.syncButtons);
        if (this.productInfo) this.observer.observe(this.productInfo, { attributes: true, attributeFilter: ['disabled','aria-disabled'], childList: true, subtree: true });
        window.setTimeout(this.syncButtons, 0);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
